const jobs = [
  { id: 1, title: "Frontend Intern", company: "Acme Corp", location: "Remote", type: "Internship" },
  { id: 2, title: "Web Developer", company: "Tech Solutions", location: "On-site", type: "Full-time" },
  { id: 3, title: "React Developer", company: "InnovateX", location: "Remote", type: "Full-time" },
  { id: 4, title: "Backend Intern", company: "DevHub", location: "On-site", type: "Internship" },
  { id: 5, title: "UI/UX Designer", company: "Creative Labs", location: "Remote", type: "Full-time" }
];

export default jobs;
